import { render, staticRenderFns } from "./employeeDocuments.vue?vue&type=template&id=54668c50&scoped=true"
import script from "./employeeDocuments.vue?vue&type=script&lang=js"
export * from "./employeeDocuments.vue?vue&type=script&lang=js"
import style0 from "./employeeDocuments.vue?vue&type=style&index=0&id=54668c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54668c50",
  null
  
)

export default component.exports